import { render, staticRenderFns } from "./addTagDialog.vue?vue&type=template&id=5700173f&scoped=true"
import script from "./addTagDialog.vue?vue&type=script&lang=js"
export * from "./addTagDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700173f",
  null
  
)

export default component.exports